import { useMemoizedFn } from 'ahooks';
import { useAppSelector } from 'app/hooks';
import { FilterTabEnum, JobItem } from 'domains/workspaceDomain';

type Props = {
  tabDisplays: { [index: string]: string };
  tab: FilterTabEnum;
  job: JobItem;
};
export const JobTabDisplay = (props: Props) => {
  const {
    tabDisplays,
    tab,
    job: { id, quoteId },
  } = props;
  const renderNumber = (num: number) => {
    return num ? `(${num})` : '';
  };
  const jobItemCounts = useAppSelector(
    (state) => state.workspace.jobItemCounts
  );

  const render = useMemoizedFn(() => {
    const itemCount = jobItemCounts.find((item) => {
      const { jobId } = item;
      if (id === -1) {
        return jobId === quoteId;
      }
      return jobId === id;
    });
    if (tab === FilterTabEnum.NOTES) {
      return `${tabDisplays[tab]} ${renderNumber(
        itemCount?.jobNotesCount || 0
      )}`;
    } else if (tab === FilterTabEnum.ACTIVITY) {
      return `${tabDisplays[tab]} ${renderNumber(
        itemCount?.jobActivitiesCount || 0
      )}`;
    } else if (tab === FilterTabEnum.FILES) {
      return `${tabDisplays[tab]} ${renderNumber(itemCount?.filesCount || 0)}`;
    } else if (tab === FilterTabEnum.PROOFS) {
      return `${tabDisplays[tab]} ${renderNumber(itemCount?.proofsCount || 0)}`;
    } else {
      return tabDisplays[tab];
    }
  });

  return <>{render()}</>;
};
